"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenomeIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** GenomeIcon */
var GenomeIcon = function GenomeIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Genome" : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), _react.default.createElement(_Icon.Title, null, title), _react.default.createElement(_Icon.Path, {
    d: "M12 4H5.95v1H12V4zm0-1v-.988h.997V5.59c0 1.358-.728 2.665-2.364 3.421 1.632.769 2.364 2.09 2.364 3.51v1.69a.252.252 0 0 1 .003.039v.466a.252.252 0 0 1-.003.039v1.22H12v-1.01H5.95V16H5v-3.48c0-1.42.731-2.739 2.361-3.507C5.726 8.262 5 6.969 5 5.62V2h.95v1H12zm.002 3H5.957c.019.317.085.664.325.995.509.703 1.386 1.236 2.716 1.502 1.33-.266 2.206-.803 2.716-1.515.233-.326.281-.668.288-.982zM12 14v-1.01H5.95V14H12zm-.042-2.01c-.18-1.09-.967-2.063-2.96-2.475-1.993.412-2.815 1.385-3.004 2.475h5.964z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.GenomeIcon = GenomeIcon;
GenomeIcon.displayName = "GenomeIcon";
//# sourceMappingURL=GenomeIcon.js.map